<template>
  <div>
    <div class="dbs_pr-common-loading-indicator" v-if="isLoading" :style="loadingStyle">
      <div class="css3loader css3loader-3 dbs_pr-common-loading-indicator__loader"></div>
      {{ loadingText }}
    </div>
    <slot v-else />
  </div>
</template>
<script>
export default {
  props: ['isLoading', 'loadingText', 'loadingStyle'],
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  }
}
</script>
<style lang="scss">
  .dbs_pr-common-loading-indicator {
    &__loader.css3loader {
      width: 10px;
      height: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LoadingIndicator.vue